@if (authUser(); as user) {
	<!-- Desktop Header -->
	<div class="admin-navigation-template__header-desktop">
		<div class="admin-navigation-template__header-desktop-left">
			<button
				tuiIconButton
				appearance="ghost"
				size="m"
				(click)="onToggleSidebar()"
			>
				@if (sidebarCollapsed()) {
					<tui-icon size="m" icon="@tui.menu" />
				} @else {
					<tui-icon size="m" icon="@tui.arrow-left-to-line" />
				}
			</button>

			<img
				draggable="false"
				class="admin-navigation-template__header-desktop-wordmark"
				src="assets/images/wordmark.png"
			/>
		</div>

		<div class="admin-navigation-template__header-desktop-right">
			<button
				tuiButton
				appearance="ghost"
				size="m"
				[tuiDropdown]="accountDropdown"
				[(tuiDropdownOpen)]="accountMenuOpen"
			>
				@if (user.role !== 'super') {
					<ctx-avatar [user]="user" />
				} @else {
					<ctx-avatar [user]="user" />
				}

				<div
					class="admin-navigation-template__header-desktop-right-name text-left"
				>
					<p class="font-bold">
						{{ user | userName }}
					</p>

					<p class="font-size-xsmall color-tertiary">
						{{ user.email }}
					</p>
				</div>

				<tui-icon icon="@tui.chevron-down" />
			</button>

			<ng-template #accountDropdown>
				<ctx-detail-menu-dropdown [menuItems]="accountMenuItems()">
					<div
						header
						class="bg-primary-100 py-3 px-4 mt-[-4px] mx-[-6px] text-center flex flex-col items-center gap-2"
					>
						<ctx-avatar [user]="user" />

						<div class="flex flex-col items-center">
							<p class="font-bold text-black text-xs">
								{{ user | userName }}
							</p>
							<p class="text-xs text-black opacity-50">
								{{ user.email }}
							</p>
						</div>
					</div>

					<div class="text-right border-t border-gray-300 p-2">
						<p class="font-size-xsmall color-tertiary opacity-50">
							{{
								'app.version' | transloco: { version: version }
							}}
						</p>
					</div>
				</ctx-detail-menu-dropdown>
			</ng-template>
		</div>
	</div>

	<!-- Mobile Header -->
	<div class="admin-navigation-template__header-mobile">
		<button
			tuiIconButton
			class="secondary"
			appearance="ghost"
			size="m"
			(click)="onMenuOpen()"
		>
			<tui-icon size="l" icon="@tui.menu" />
		</button>
	</div>

	<!-- Desktop and Mobile Main Stage -->
	<div class="admin-navigation-template__main">
		<!-- Desktop Sidebar -->
		<div class="admin-navigation-template__main-sidebar">
			<div class="admin-navigation-template__main-sidebar-top">
				@if (sidebarCollapsed()) {
					<button
						tuiIconButton
						iconStart="@tui.plus"
						size="l"
						appearance="primary"
						(click)="onPromptCreate()"
					></button>
				} @else {
					<button
						tuiButton
						iconStart="@tui.plus"
						size="l"
						appearance="primary"
						(click)="onPromptCreate()"
					>
						{{ 'action.create-new' | transloco }}
					</button>
				}
			</div>

			<div class="admin-navigation-template__main-sidebar-navigation">
				@for (item of sidebarMenuItems; track item.key) {
					@if (item.location === 'side' || item.location === 'all') {
						@if (item.badge$ | async; as count) {
							<tui-badged-content>
								<tui-badge-notification tuiSlot="top">
									{{ count }}
								</tui-badge-notification>

								<ng-container
									*ngTemplateOutlet="
										sidebarButtonContent;
										context: { item }
									"
								/>
							</tui-badged-content>
						} @else {
							<ng-container
								*ngTemplateOutlet="
									sidebarButtonContent;
									context: { item }
								"
							/>
						}
					}
				}
			</div>
		</div>

		<div class="admin-navigation-template__main-route-container">
			<router-outlet />
		</div>
	</div>

	<!-- Mobile Tab Bar -->
	<nav class="admin-navigation-template__tab-bar" tuiTabBar>
		@for (item of sidebarMenuItems; track item.key) {
			@if (item.location === 'tab' || item.location === 'all') {
				<tui-badged-content>
					@if (item.badge$ | async; as count) {
						<tui-badge-notification tuiSlot="top">
							{{ count }}
						</tui-badge-notification>
					}

					@if (item.handler) {
						<a
							class="cursor-pointer"
							[icon]="item.icon"
							tuiTabBarItem
							(click)="item.handler()"
						>
							{{ 'navigation.' + item.key | transloco }}
						</a>
					} @else if (item.route) {
						<a
							class="cursor-pointer"
							[icon]="item.icon"
							routerLinkActive="active"
							tuiTabBarItem
							[routerLink]="item.route"
						>
							{{ 'navigation.' + item.key | transloco }}
						</a>
					}
				</tui-badged-content>
			}
		}
	</nav>

	<ng-template #createTemplate>
		<section tuiContent>
			@for (entity of entityTypes; track entity.key) {
				<button
					tuiButton
					class="menu-button"
					[iconStart]="entity.icon"
					iconEnd="@tui.chevron-right"
					(click)="onCreate(entity.key)"
				>
					<span>{{ 'data.' + entity.key | transloco }}</span>
				</button>
			}
		</section>
	</ng-template>

	<ng-template #sidebarButtonContent let-item="item">
		@if (item.handler) {
			<a tuiLink size="l" class="nav-button" (click)="item.handler()">
				<tui-icon [icon]="item.icon" />
				@if (!sidebarCollapsed()) {
					{{ 'navigation.' + item.key | transloco }}
				}
			</a>
		} @else {
			<a
				tuiLink
				size="l"
				class="nav-button"
				[routerLink]="[item.route]"
				routerLinkActive="active"
			>
				<tui-icon [icon]="item.icon" />
				@if (!sidebarCollapsed()) {
					{{ 'navigation.' + item.key | transloco }}
				}
			</a>
		}
	</ng-template>
}
